/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from "react";
import { Tag, Select, Checkbox, Button, Modal } from "antd";
import { FaRegBell, FaRegFolderOpen } from "react-icons/fa";

const Option = Select.Option;
//showArchive = canManagePolicy('USER_TASK') && userTaskData && !userTaskData.archived
//shpwWontcomplete  = canManagePolicy('USER_TASK') && props?.userTaskPageSettings?.['wont-complete-button-visible'] !== false
//showUpdate =  canManagePolicy('USER_TASK')
//showComplete=  canManagePolicy('USER_TASK')
const TaskFooter = React.memo((props: any) => {
  const {
    drawerExpanded,
    showDocumentViewer,
    userTask,
    archiveTask,
    userTaskLoading,
    updatedCustomFormRequirementsMap,
    customFormFieldsDisabled,
    isSubmitting,
    wontCompleteForm,
    completeForm,
    updateForm,
    isMobile,
    itsTimeToSave,
    drawerOpen,
  } = props;

  const { showArchive, showUpdate, showWontcomplete, showComplete } = props;
  
  const [showWontCompleteReasonDialog, setShowWontCompleteReasonDialog] =
    useState(false);

  const [wontCompleteReason, setWontCompleteReason] = useState("");
  const [enableModalSubmitButton, setEnabledModalSubmitButton] = useState(false);
  
    const { update, complete, wontcomplete, archive } =
    updatedCustomFormRequirementsMap?.actions || {};

  const updateActive =
    !customFormFieldsDisabled &&
    !isSubmitting &&
    !userTaskLoading &&
    (update && update.length > 0 ? update.every((f) => f.active) : true);
  // const completeActive = !customFormFieldsDisabled && !isSubmitting && !userTaskLoading && (complete && complete.length > 0 ? complete.every((f) => f.active) : true);
  //const wontcompleteActive = !customFormFieldsDisabled && !isSubmitting && !userTaskLoading && (wontcomplete && wontcomplete.length > 0 ? wontcomplete.every((f) => f.active) : true);
  //const archiveActive = !isSubmitting && !userTaskLoading && (archive && archive.length > 0 ? archive.every((f) => f.active) : true);

  return (
    <div
      className="footerContainer"
      style={{ display: drawerOpen ? "default" : "none" }}
    >
      {itsTimeToSave && updateActive && (
        <div
          className="footerTop"
          style={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            justifyContent: "flex-end",
            alignItems: "center",
            position: "fixed",
            right: 16,
            bottom: 50,
            width: isMobile
              ? window.screen.width
              : drawerExpanded
                ? Math.max(740, window.innerWidth - 200)
                : showDocumentViewer
                  ? "50%"
                  : 740,
            borderTop: "1px solid #e9e9e9",
            padding: "10px 16px",
            background: "#fff",
            zIndex: 1,
            color: "red",
            fontWeight: "bold",
            //justifyContent: 'center',
          }}
        >
          <Tag color="orange">
            Please save (click Update) long forms frequently
          </Tag>
        </div>
      )}
      <div
        className="footerBelow"
        style={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          justifyContent: "flex-end",
          alignItems: "center",
          position: "fixed",
          right: 16,
          bottom: 0,
          width: isMobile
            ? window.screen.width
            : drawerExpanded
              ? Math.max(740, window.innerWidth - 200)
              : 740,
          borderTop: "1px solid #e9e9e9",
          padding: "10px 16px",
          background: "#fff",
          zIndex: 1,
        }}
      >
        <Checkbox.Group
          style={{ display: "inline-flex", alignItems: "center", flexGrow: 1 }}
        >
          <FaRegBell
            style={{ fill: "#71afb4", width: "1em", fontSize: "1rem" }}
          />
          &nbsp; Reminders&nbsp;&nbsp;
          <Checkbox checked disabled value="sms">
            Text
          </Checkbox>
          <Checkbox checked disabled value="email">
            Email
          </Checkbox>
        </Checkbox.Group>
        <div
          style={{
            display: "flex",
            justifyContent: isMobile ? "space-between" : "flex-end",
            alignItems: "center",
            marginTop: isMobile ? 20 : 0,
            width: isMobile ? window.screen.width - 30 : "auto",
          }}
        >
          {showArchive && (
            <Button
              style={{
                marginRight: isMobile ? 0 : 8,
                borderColor: isMobile
                  ? "transparent"
                  : "rgba(121, 121, 121, 1)",
                color: "#797979",
                padding: isMobile ? 0 : "0 15px",
              }}
              icon={
                isMobile ? undefined : (
                  <FaRegFolderOpen
                    style={{
                      fill: "#71afb4",
                      verticalAlign: "baseline",
                      fontSize: 16,
                      marginRight: 3,
                    }}
                  />
                )
              }
              type="ghost"
              onClick={archiveTask}
              loading={isSubmitting === "archive"}
              disabled={
                !userTask?.customFormServiceInstanceId ||
                customFormFieldsDisabled ||
                isSubmitting ||
                userTaskLoading
              }
              data-cy="archive"
            >
              Archive
            </Button>
          )}
          {showWontcomplete && (
            <Button
              style={{
                marginRight: isMobile ? 0 : 30,
                borderColor: isMobile
                  ? "transparent"
                  : "rgba(121, 121, 121, 1)",
                color: "#797979",
                padding: isMobile ? 0 : "0 15px",
              }}
              type="ghost"
              onClick={() => {
                setShowWontCompleteReasonDialog(true);
              }}
              loading={isSubmitting === "wontcomplete"}
              disabled={
                !userTask?.customFormServiceInstanceId ||
                customFormFieldsDisabled ||
                isSubmitting ||
                userTaskLoading
              }
              data-cy="wontcomplete"
            >
              Won't Complete
            </Button>
          )}
          {showUpdate && (
            <Button
              style={{
                marginRight: isMobile ? 0 : 30,
                borderColor: "rgba(45, 78, 119, 1)",
                color: "rgba(45, 78, 119, 1)",
                padding: isMobile ? "0 5px" : "0 15px",
              }}
              //type="secondary"
              onClick={updateForm}
              loading={isSubmitting === "update"}
              
              data-cy="update"
            >
              Update
            </Button>
          )}
          {showComplete && (
            <Button
              style={
                !customFormFieldsDisabled && !isSubmitting && !userTaskLoading
                  ? {
                      marginRight: isMobile ? 0 : 8,
                      backgroundColor: "rgba(225, 126, 37, 1)",
                      borderColor: "rgba(225, 126, 37, 1)",
                      padding: isMobile ? "0 5px" : "0 15px",
                    }
                  : { marginRight: 8, padding: isMobile ? "0 5px" : "0 15px" }
              }
              type="primary"
              onClick={completeForm}
              loading={isSubmitting === "complete"}
              disabled={
                customFormFieldsDisabled || isSubmitting || userTaskLoading
              }
              data-cy="complete"
            >
              Complete
            </Button>
          )}
        </div>
        <Modal
          title="Won't Complete"
          open={showWontCompleteReasonDialog}
          onCancel={(e) => {
            setShowWontCompleteReasonDialog(false);
          }}
          footer={[
            <Button
              key="back"
              onClick={(e) => {
                setShowWontCompleteReasonDialog(false);
              }}
            >
              Cancel
            </Button>,
            <Button
              key="submit"
              disabled={!enableModalSubmitButton}
              type="primary"
              onClick={(e) => {
                setShowWontCompleteReasonDialog(false);
                wontCompleteForm(wontCompleteReason);
              }}
            >
              OK
            </Button>,
          ]}
        >
          <p style={{ fontWeight: 800, marginBottom: "1em" }}>
            Please select the reason you won't be completing this task from the
            options below:
          </p>
          <Select
            showSearch
            showAction={["focus", "click"]}
            style={{ width: 250 }}
            placeholder="Select a reason"
            onChange={(e) => {
              setWontCompleteReason(e);
              setEnabledModalSubmitButton(true);
            }}
          >
            <Option value="REASON_1">Task not applicable</Option>
            <Option value="REASON_2">Unable to complete</Option>
            <Option value="REASON_3">
              No longer providing care to this patient
            </Option>
            {/* <Option value="REASON_4">Reason 4</Option> */}
            {/* <Option value="REASON_5">Reason 5</Option> */}
          </Select>
        </Modal>
      </div>
      <style>{`
            .footerContainer {
              display: grid;
              grid-template: 1fr / 1fr;
              place-items: center;

            }
            .footerContainer > * {
              grid-column: 1 / 1;
              grid-row: 1 / 1;
            }
            .footerContainer .footerBelow {
              z-index: 2;
            }
            .footerContainer .footerTop {
              z-index: 1;
            }
          `}</style>
    </div>
  );
});

export default TaskFooter;
